import "./scripts/StyleLoader";

import FavoritesHandler from "./scripts/FavoritesHandler";
import CollapseHandler from "./scripts/CollapseHandler";

import scrollToToP from "./scripts/ScrollToToP";
import initSearch from "./scripts/InitSearch";
import MobileMenuHandler from "./scripts/MobileMenuHandler";
import SimpleToggle from "./scripts/SimpleToggle";
import "./scripts/FormatDates";
import ClerkService from "./services-js/ClerkService";

// initializer
window.addEventListener("DOMContentLoaded", async () => {
    new FavoritesHandler();
    new CollapseHandler();
    const clerkLoader = new ClerkService({});

    scrollToToP();
    initSearch();
    MobileMenuHandler();
    SimpleToggle();
});

import "./components/app";

import "./services-js/StyleProperties";

